/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useState } from "react";
import XhtmlEntry from "./JoditEditor";
import { ButtonWithConfirmModal } from "../components/ConfirmModal";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const DisplayFromFHIRXhtml = ({ xhtml }) => {
    if (xhtml) {
        if (Array.isArray(xhtml) || typeof xhtml !== "string") {
            return <>[ERROR: Xhtml data not interpretable.]</>;
        }
        try {
            return <span>
                <ReactMarkdown children={xhtml} rehypePlugins={[rehypeRaw]} /></span>
        } catch (e) {
            return <>[ERROR: Problem with the xhtml format. {e}] {xhtml}</>;
        }

    } else {
        return <></>
    }
}

const clearDivWrapper = (divText) => {
    if (divText && typeof (divText) === "string") {
        if (divText.substring(0, 42) === '<div xmlns="http://www.w3.org/1999/xhtml">' && divText.substring(divText.length - 6) === '</div>') {
            divText = divText.substring(42, divText.length - 6);
        }
    }
    return divText;
};

const emptyTextNoData = {
    "status": "empty",
    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
};

const getStartingNarrativeFromStartingValue = (startingValue) => {
    let startingNarrative = JSON.parse(JSON.stringify(emptyTextNoData));
    if (startingValue) {
        if (startingValue.extension) { startingNarrative.extension = startingValue.extension; }
        if (startingValue.status) { startingNarrative.status = startingValue.status; }
        if (startingValue.div) { startingNarrative.div = startingValue.div; }
    }
    let startingDivTextValue = clearDivWrapper(startingNarrative.div);
    let startingDivValue = { "divText": startingDivTextValue };
    return [startingNarrative, startingDivValue];
};

const NarrativeEntry = memo(({ elementName, startingValue = {}, setResourceState,
    generatedNarrative }) => {
    let [startingNarrative, startingDivValue] = getStartingNarrativeFromStartingValue(startingValue);
    const [narrativeState, setNarrativeState] = useState(JSON.parse(JSON.stringify(startingNarrative || {})));
    const [narrativeDivState, setNarrativeDivState] = useState(JSON.parse(JSON.stringify(startingDivValue || {})));
    const [generatedNarrativeState, setGeneratedNarrativeState] = useState(false);
    const checkIfStatusAdditional = () => {
        return narrativeState.status === "additional";
    };
    const updateNarrativeStates = () => {
        setGeneratedNarrativeState(true);
        let divText = clearDivWrapper(generatedNarrative.div);
        setNarrativeDivState({ "divText": divText });
    }

    useEffect((() => {
        if (Object.keys(narrativeState).length) {
            let newNarrative = {};
            if (narrativeState.extension) { newNarrative.extension = narrativeState.extension; }
            if (narrativeState.status) { newNarrative.status = narrativeState.status; }
            if (narrativeState.div) { newNarrative.div = narrativeState.div; }
            if (Object.keys(newNarrative).length === 0 ||
                (newNarrative.status === "empty" && !newNarrative.div && !newNarrative.extension)) {
                newNarrative = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newNarrative } });
        }
    }), [narrativeState]);

    useEffect((() => {
        if (generatedNarrativeState === true) {
            setGeneratedNarrativeState(false);
            setNarrativeState(prevState => { return { ...prevState, "status": generatedNarrative.status, "div": generatedNarrative.div } });
        } else if (generatedNarrativeState === false && (startingDivValue.divText !== narrativeDivState.divText) &&
            (("<p>" + startingDivValue.divText + "</p>") !== narrativeDivState.divText)
        ) {
            if ((narrativeDivState.divText || narrativeDivState.divText === "0") &&
                narrativeDivState.divText !== '[No data]' &&
                narrativeDivState.divText !== '[No data.]' &&
                narrativeDivState.divText !== '<p>[No data.]</p>' &&
                narrativeDivState.divText !== '<p><br></p>' &&
                narrativeDivState.divText !== '<p><br/></p>' && narrativeDivState.divText !== '<p></p>') {
                setNarrativeState(prevState => { return { ...prevState, "status": "additional", "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + narrativeDivState.divText + "</div>" } });
            } else if (narrativeDivState.divText) {
                setNarrativeState(prevState => { return { ...prevState, "status": "empty", "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + narrativeDivState.divText + "</div>" } });
            } else {
                setNarrativeState(prevState => { return { ...prevState, "status": "empty", "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>' } });
            }
        }
    }), [narrativeDivState]);

    return <div>
        {generatedNarrative && <ButtonWithConfirmModal buttonContent="Generate Natural Language Summary"
            message="This will overwrite the manually edited summary with a generated summary."
            conditionForConfirmModal={checkIfStatusAdditional}
            functionIfConfirmed={updateNarrativeStates}
        />}
        <p style={{ marginBottom: "0px" }}><b>Natural language summary: </b>
            (status: {narrativeState.status === "additional" ? "manually edited" : narrativeState.status})</p>
        <div style={{ marginLeft: "24px" }}>
            <XhtmlEntry elementName='divText'
                startingValue={narrativeDivState.divText} setResourceState={setNarrativeDivState} />
        </div>
    </div>
});

export default NarrativeEntry;
export { emptyTextNoData, DisplayFromFHIRXhtml, clearDivWrapper };